module.exports = __webpack_public_path__ + "img/portfolio-04.6fae64a7.jpg";